import { LE } from "@/constants/enums";
import { type Inquiry, type InquiryFormKit, type InquiryNew } from "@/views/inquiry/inquiry";
import { plainMurnAddressFromFormkit, plainMurnAddressToFormkit } from "@modernary/mui/components/fk";
import { fillAddressLookupValues, fillLookupValuesByPropertyNames, fillPrefixedAddressLookupValues } from "@modernary/mui/components/lookup";

export default {
  addAuthRequestFields,
  getInitialData,
  fromFormkit,
  toFormkit,
  skinnyResponseAdapter,
  responseAdapter,
};

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Inquiry }) {
  addAuthRequestFields(response.data);
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Inquiry }) {
  await skinnyResponseAdapter(response);
  await fillAddressLookupValues(response.data);
  return response.data;
}

function addAuthRequestFields(entity: Inquiry | InquiryNew) {
  entity._authRequestFields = ["id", "statusMurn"] as (keyof Inquiry)[];
  return entity;
}

function getInitialData() {
  const result = {} as Inquiry; //TODO:TS
  return addAuthRequestFields(result);
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: Inquiry) {
  plainMurnAddressToFormkit(data);
  //TODO: Mask Bug phone number only set to be undefined to fix formkit bug. Once formkit resolves bug remove
  if (!data.callerPhone) {
    data.callerPhone = undefined;
  }
}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: InquiryFormKit) {
  plainMurnAddressFromFormkit(data as Inquiry);
  //TODO: Mask Bug remove this once the if above is removed.
  if (data.callerPhone === undefined) {
    data.callerPhone = null;
  }
  if (data.exposedPersonAge) {
    data.exposedPersonAge = data.exposedPersonAge.toString();
  }
}